import React,{ useState } from "react";
import '../css/newproject.css';
import history from '../imgs/his.png';
import show from '../imgs/shows.png';
import drama from '../imgs/drama.png';
import vasantha from '../imgs/vasanthama.png'; 
import { VasanthamaligaiDetail } from "./VasanthamaligaiDetail";

const projects = [
    {
        title: "Micro Drama OTT ",
        image: drama,
        description:
            "A compelling series of short-format dramas crafted for impactful storytelling within a concise runtime. Each episode is designed to deliver strong emotional arcs, relatable characters, and thought-provoking themes, making it ideal for today’s fast-paced digital audience while maintaining cinematic quality.",
    },
    {
        title: "Historical Web Series",
        image: history,
        description:
            "An ambitious web series that brings history to life with rich visuals, authentic narratives, and powerful storytelling. Rooted in extensive research, this project aims to present significant historical events and figures in a gripping, contemporary format that appeals to both young audiences and history enthusiasts.",
    },
    {
        title: "Hybrid Variety Television Project (Fiction x Non-Fiction) ",
        image: show,
        description:
            "An innovative television experience that seamlessly blends scripted storytelling with real-life moments. This hybrid format brings together the emotional depth of fiction and the spontaneity of non-fiction, creating a dynamic viewing experience filled with engaging narratives, celebrity interactions, and immersive audience participation. Designed for modern viewers, this project redefines conventional variety entertainment.",
    },
      {
        title: "Vasanthamaligai",
        image: vasantha,
        description:
            "A vibrant family game show where families compete in exciting challenges to win household prizes and earn a Golden Ticket — their entry into the ultimate Dream Home finale, 'Vasantha Maligai.' A celebration of family, knowledge, and dreams.",
        isSpecial: true, 
        badge: "FEATURED",
    },
];


export const Newproject = () => {

    const [showDetail, setShowDetail] = useState(false);
    if (showDetail) {
        return <VasanthamaligaiDetail onBack={() => setShowDetail(false)} />;
    }

    return (
         <div className="app11">
            <h1 className="heading11">Upcoming Projects</h1>
 
            <div className="card-container11">
                {projects.map((item, index) => (
                    <div
                        className={`card11 ${item.isSpecial ? "card11--featured" : ""}`}
                        key={index}
                        onClick={item.isSpecial ? () => setShowDetail(true) : undefined}
                        style={item.isSpecial ? { cursor: "pointer" } : {}}
                    >
                        <img src={item.image} alt={item.title} className="card-img11" />
 
                        <div className="card-overlay11"></div>
 
                        <span className="card-badge">{item.badge || "NEW"}</span>
 
                        <div className="card-touch">
                            {item.isSpecial ? "Tap to Explore ✦" : "Tap to Explore"}
                        </div>
 
                        <div className="card-content11">
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

